export default __webpack_public_path__ + "static/media/zero_many_each.39a31120.gif";